function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24a11.916 11.916 0 01-8.442-3.481.298.298 0 01-.042-.035.295.295 0 01-.036-.045A11.894 11.894 0 010 12a11.994 11.994 0 0120.443-8.519.349.349 0 01.042.034.28.28 0 01.032.04A11.994 11.994 0 0112 24zm-7.411-3.882A10.991 10.991 0 0020.118 4.589zM12 1a10.991 10.991 0 00-8.118 18.411L19.411 3.882A10.938 10.938 0 0012 1z"
});

function SvgFormError(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "formError.da486.svg";
export { SvgFormError as ReactComponent };